import React, { useState } from "react";
import Card from "../Components/Card.js";
import cancel from "../Assets/cancel.png";

const Home = () => {
  const [forecast, setForecast] = useState([]);
  const [city, setCity] = useState("");
  const [searches, setSearches] = useState([]);
  const [isActive,setIsActive] = useState(null);
  const [isCurrent,setIsCurrent] = useState(null);
  const [newSearch,setNewSearch] = useState(true);
  const [editSearch, setEditSearch] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);

  const handleSelect = (e) => {
    e.target.select();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // console.log(value);
    setCity(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // setIsLoading(true);
    const allSearches = [...searches];
    if (city.length > 0) {
    getGeoData(city);
    }
    if (city.length < 3) {
      return;
    } else {
    allSearches.push(city);
    setSearches(allSearches);
    const capitalCaseArr = allSearches.map(city => {
      if (/\s/.test(city) === true) {
        let cityArray = city.split(" ");
        let cityMap = cityArray.map(str => str.charAt(0).toUpperCase() + str.substring(1).toLowerCase());
        let cityStr = cityMap.join(" ");
        // console.log(cityStr);
        return cityStr;
      } else if (/,/.test(city) === true) {
        // let test = /,/.test(city);
        // console.log(test);
        let cityArray = city.split(",");
        let cityMap = cityArray.map(str => str.charAt(0).toUpperCase() + str.substring(1).toLowerCase());
        let cityStr = cityMap.join(", ");
        // console.log(cityStr);
        return cityStr;
      } else {
        return city.charAt(0).toUpperCase() + city.substring(1).toLowerCase();
      }
    })
    // console.log(capitalCaseArr);
    setSearches(capitalCaseArr);
    }
    setEditSearch(false);
    setIsActive(null);
    setIsCurrent(true);
    setNewSearch(false);
  };

  const handleClick = (e, index, city) => {
    // console.log(i,"index",city,searches[i]);
    // console.log(index, city, searches);
    setIsActive(index);
    setIsCurrent(index);
    getGeoData(city);
  }

  const showForm = () => {
    setNewSearch(true);
    // setIsCurrent(null);
  }

  const handleEdit = () => {
    setEditSearch(current => !current);
  }

  const handleRemove = (e, index) => {
     const allSearches = [...searches];
     allSearches.splice(index, 1);
     setSearches(allSearches);
     setIsActive(0);
     setIsCurrent(null);
     if (allSearches.length > 0) {
     getGeoData(allSearches[0]);
     } else if (allSearches.length === 0) {
      setCity("");
      setForecast([]);
     }
  }

  const getGeoData = async (place) => {
    let geoKey = process.env.REACT_APP_GEO_KEY;
    let geoResponse = await fetch(
      `https://api.geoapify.com/v1/geocode/search?text=${place}&format=json&apiKey=${geoKey}`
    );
    let geoData = await geoResponse.json();
    // console.log(geoData);
    if (geoData.results.length === 0) {
      setCity("Try again");
      return;
    }
    //need error handling if user misspelled a city
    let lon = geoData.results[0].lon;
    let lat = geoData.results[0].lat;
    // console.log(geoData.results, lat, lon);
    let apiKey = process.env.REACT_APP_API_KEY;
    let response = await fetch(
      `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&exclude=minutely,hourly&appid=${apiKey}`
    );
    let data = await response.json();
    setForecast(data.daily);
    // console.log(data.daily);
    // setIsLoading(false);
    // let cityStr = city.length <= 3 ? geoData.results[1] : geoData.results[0];
    setCity(place);
    return data;
  };

  // Date.prototype.addDays = function (days) {
  //   const day = new Date(this.valueOf());
  //   day.setDate(day.getDate() + days);
  //   const str = day.toString();
  //   const arr = str.split(" ");
  //   const newArr = arr.slice(0, 3);
  //   // console.log(newArr); //returns Weekday Month Day
  //   return newArr;
  // };

  // useEffect(() => {
  //   getGeoData(city);
  // }, [city]);

  return (
    <div>
      {newSearch ? (
      <form className="search-section" onSubmit={handleSubmit}>
        <input
          className="search-field"
          name="city"
          type="text"
          placeholder="Enter city, state/province and/or country"
          value={city}
          onChange={handleChange}
          onClick={handleSelect}
        ></input>
        <button className="search-button" type="submit">
         Get Weather!
        </button>
      </form>
      ) : <div className="search-section"><button className="search-button" onClick={showForm}>
          New Search
        </button></div>}
      {searches.length > 0 ? 
      <div className="search-section all-search-section">
        <h2>Previous Searches</h2>
        <div className="all-searches">
        {editSearch === false ? searches.map((location, index) =>
        index === searches.length - 1 ?
         <span className={isCurrent === true ? "previous-search-current" : isCurrent === index || isActive === index ? "previous-search-active" : "previous-search"} key={index} onClick={(e) => handleClick(e, index, location)}>{location}</span>
          :
         <span className={isActive === index ? "previous-search-active" : "previous-search"} key={index} onClick={(e) => handleClick(e, index, location)}>{location}</span> 
        )
        : editSearch === true ? 
          searches.map((location, index) =>
        index === searches.length - 1 ? (
        <div className="edit-search-card" key={index}>
         <span className={isCurrent === true ? "previous-search-current" : isCurrent === index || isActive === index ? "previous-search-active" : "previous-search"}  onClick={(e) => handleClick(e, index, location)}>{location}
         </span>
         <img className="cancel" src={cancel} alt="cancel" onClick={(e) => handleRemove(e, index)}/>
         </div>)
          :
          (<div className="edit-search-card" key={index}>
         <span className={isActive === index ? "previous-search-active" : "previous-search"}  onClick={(e) => handleClick(e, index, location)}>{location}
         </span> 
          <img className="cancel" src={cancel} alt="cancel" onClick={(e) => handleRemove(e, index)}/>
         </div>)
        )
        :
        null}
        </div>
        <button className="search-button edit-button" onClick={handleEdit}>{editSearch === true ? "Save Locations" : "Edit Searches"}</button>
      </div> : null}
      <div className="weather-section">
        <div className="weather-all">
          {city && forecast.map((day, index) => {
            let date = new Date();
            // const dateVal = date.valueOf();
            date.setDate(date.getDate() + index);
            const str = date.toString();
            const arr = str.split(" ");
            const newArr = arr.slice(0, 3);
            // only spaces between day of the week and the month
            //  const dateStr = newArr.join(" ");
            const dayOfWeek = newArr.slice(0, 2);
            const dayMonth = dayOfWeek.join(", ");
            const dateStr = `${dayMonth} ${newArr[2]}`
            // console.log(dateStr);
            // console.log(city);
            if (index === 0) {
              return (
                <div key={index}>
                  <h2>Weather Today</h2>
                  <div className="weather-today">
                    <Card
                      data={day}
                      weekday={dateStr}
                      // weekday={date.addDays(0).join(" ")}
                    />
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
        {city ? (
          <h2>Weather The Week Ahead</h2>
        ) : (
          <div className="intro">
            <h2>Get a 7-Day Forecast!</h2>
            <h4>Includes:</h4>
            <p>Day of the Week</p>
            <p>Month and Day</p>
            <p>Temperature Low</p>
            <p>Temperature High</p>
          </div>
        )}
        <div className="weather-week">
          {city && forecast.map((day, index) => {
            let date = new Date();
            // const dateVal = date.valueOf();
            date.setDate(date.getDate() + index);
            const str = date.toString();
            const arr = str.split(" ");
            const newArr = arr.slice(0, 3);
            // only spaces between day of the week and the month
            //  const dateStr = newArr.join(" ");
            const dayOfWeek = newArr.slice(0, 2);
            const dayMonth = dayOfWeek.join(", ");
            const dateStr = `${dayMonth} ${newArr[2]}`
            // console.log(dateStr);
            if (index > 0) {
              return (
                <Card
                  data={day}
                  key={index}
                  weekday={dateStr}
                  // weekday={date.addDays(index).join(" ")}
                />
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default Home;
